<div class="confirmation-container">
  <div class="confirmation-header">
    <p class="float-left title">Are you sure to delete {{ data.name }}?</p>
    <img class="float-right close" src="assets/images/close@2x.png" (click)="closeModal(false)" />
  </div>
  <div class="confirmation-data">
    <div class="confirm-action">
      <button type="button" class="create-action text-capitalize btn btn-primary" (click)="onSubmit()">
        <span>{{ buttonLableSubmit }}</span>
      </button>
      @if (buttonLableCancel) {
        <button type="button" class="cancel-action btn" style="background-color: #e6e6e6" (click)="closeModal(false)"
          >
          <span> {{ buttonLableCancel }}</span>
        </button>
      }
    </div>
    <div class="clearfix"></div>
  </div>
</div>